module.exports = __webpack_public_path__ + "static/media/covi_org_sta_spa.f1e78059.png";